import React from "react";
import ModuleRatings from "../../components/Ratings/ModuleRatings";
import CourseAdminNav from "../../components/Navigation/CourseAdminNav";
import { useLocation } from "react-router-dom";
import useRedirectIf from "../../hooks/useRedirectIf";

function Ratings() {
  const location = useLocation();

  useRedirectIf("/superuser/courses", !location.state);

  if (!location.state) {
    return null;
  }

  var table = location.state.table;
  return (
    <div>
      <CourseAdminNav table={table} />
      <ModuleRatings table={table} />
    </div>
  );
}

export default Ratings;
